import { TYPOGRAPHY_TAGS, VerticalRhythmStrategies } from 'mm-theme-configuration';
import { VerticalRhythm, VrLineHeight, VerticalRhythmStrategy, VrSet } from './verticalRhythm';
import { MEDIA_BREAKPOINTS } from '../../mediaQueries.const';

const createVrFromStrategy = (strategy: VerticalRhythmStrategy): VerticalRhythm => new VerticalRhythm(strategy);

const createTagStyle = (verticalRhythmStrategies: VerticalRhythmStrategies) => (tagName: keyof VerticalRhythm) => ({
  [MEDIA_BREAKPOINTS.LARGE]: createVrFromStrategy(verticalRhythmStrategies.large)[tagName],
  [MEDIA_BREAKPOINTS.MEDIUM]: createVrFromStrategy(verticalRhythmStrategies.medium)[tagName],
  [MEDIA_BREAKPOINTS.SMALL]: createVrFromStrategy(verticalRhythmStrategies.small)[tagName],
});

const createVerticalRhythm = (verticalRhythmStrategies: VerticalRhythmStrategies) => ({
  [MEDIA_BREAKPOINTS.LARGE]: createVrFromStrategy(verticalRhythmStrategies.large),
  [MEDIA_BREAKPOINTS.MEDIUM]: createVrFromStrategy(verticalRhythmStrategies.medium),
  [MEDIA_BREAKPOINTS.SMALL]: createVrFromStrategy(verticalRhythmStrategies.small),
});

const vrLineHeight = (verticalRhythm: VrSet): VrLineHeight => Object.keys(verticalRhythm).reduce((accumulator, mediaBreakpoint) => ({
  ...accumulator, [mediaBreakpoint]: verticalRhythm[mediaBreakpoint].lineHeight,
}), {});

const createTagStyles = (verticalRhythmStrategies: VerticalRhythmStrategies) => {
  const tagStyleCreator = createTagStyle(verticalRhythmStrategies);
  return Object.values(TYPOGRAPHY_TAGS)
    .reduce((accumulator, tag) => ({
      ...accumulator,
      [tag]: tagStyleCreator(tag as keyof VerticalRhythm),
    }), {});
};

export const VRFactory = (verticalRhythmStrategies: VerticalRhythmStrategies) => {
  const verticalRhythm: VrSet = createVerticalRhythm(verticalRhythmStrategies);
  return {
    vrLineHeight: vrLineHeight(verticalRhythm),
    tagStyles: createTagStyles(verticalRhythmStrategies),
  };
};
